import axios from 'axios';

/** Base templates */
export const listDynamicConfigTemplates = async () => {
    const response = await axios.get('/api/dynamic-config-template/list');
    return response.data;
};

export const createDynamicConfigTemplate = async (payload) => {
    const response = await axios.post('/api/dynamic-config-template/create', payload);
    return response.data;
};

export const getDynamicConfigDraft = async (templateId) => {
    const response = await axios.post('/api/dynamic-config-template/draft', { templateId });
    return response.data;
};

export const listBaseVersions = async (templateId) => {
    const response = await axios.get('/api/dynamic-config-template/base-versions', { params: { templateId } });
    return response.data;
};

export const getBaseVersion = async (templateId, version) => {
    const response = await axios.get('/api/dynamic-config-template/base-version', {
        params: { templateId, version },
    });
    return response.data;
};

export const saveDynamicConfigDraft = async (templateId, schema) => {
    const response = await axios.post('/api/dynamic-config-template/save-draft', { templateId, schema });
    return response.data;
};

export const restoreDraftFromBaseVersion = async (templateId, version) => {
    const response = await axios.post('/api/dynamic-config-template/restore-draft', { templateId, version });
    return response.data;
};

export const publishDynamicConfigTemplate = async (templateId) => {
    const response = await axios.post('/api/dynamic-config-template/publish', { templateId });
    return response.data;
};

/** Project instances (assign = init alias) */
export const assignDynamicConfigInstance = async (payload) => {
    const response = await axios.post('/api/dynamic-config-template/assign', payload);
    return response.data;
};

export const initProjectInstance = async (payload) => {
    const response = await axios.post('/api/dynamic-config-template/project-instances/init', payload);
    return response.data;
};

export const listProjectInstances = async (projectId) => {
    const response = await axios.get('/api/dynamic-config-template/project-instances', { params: { projectId } });
    return response.data;
};

export const getProjectInstanceDraft = async (instanceId) => {
    const response = await axios.get(`/api/dynamic-config-template/project-instances/${instanceId}/draft`);
    return response.data;
};

export const saveProjectInstanceDraft = async (instanceId, schema) => {
    const response = await axios.post(`/api/dynamic-config-template/project-instances/${instanceId}/save-draft`, {
        schema,
    });
    return response.data;
};

export const publishProjectInstance = async (instanceId) => {
    const response = await axios.post(`/api/dynamic-config-template/project-instances/${instanceId}/publish`);
    return response.data;
};

export const listProjectInstanceVersions = async (instanceId) => {
    const response = await axios.get(`/api/dynamic-config-template/project-instances/${instanceId}/versions`);
    return response.data;
};

export const getProjectInstanceVersion = async (instanceId, projectVersion) => {
    const response = await axios.get(`/api/dynamic-config-template/project-instances/${instanceId}/version`, {
        params: { projectVersion },
    });
    return response.data;
};

export const rollbackProjectInstance = async (instanceId, toProjectVersion) => {
    const response = await axios.post(`/api/dynamic-config-template/project-instances/${instanceId}/rollback`, {
        toProjectVersion,
    });
    return response.data;
};

export const unpublishProjectInstance = async (instanceId, projectVersion) => {
    const response = await axios.post(`/api/dynamic-config-template/project-instances/${instanceId}/unpublish`, {
        projectVersion,
    });
    return response.data;
};

export const rebaseProjectInstanceDraft = async (instanceId, baseVersion) => {
    const response = await axios.post(`/api/dynamic-config-template/project-instances/${instanceId}/rebase-draft`, {
        baseVersion,
    });
    return response.data;
};

export const saveProjectInstancePreviewLink = async (instanceId, previewLink) => {
    const response = await axios.post(`/api/dynamic-config-template/project-instances/${instanceId}/preview-link`, {
        previewLink: previewLink ?? "",
    });
    return response.data;
};

export const saveProjectVersionPreviewLink = async (instanceId, projectVersion, previewLink) => {
    const response = await axios.post(
        `/api/dynamic-config-template/project-instances/${instanceId}/version/${projectVersion}/preview-link`,
        { previewLink: previewLink ?? "" }
    );
    return response.data;
};

/**
 * Phase C (deferred): publisher form renderer loads assigned instance + published projectVersion,
 * validates submission JSON, persists to template_submissions (or equivalent).
 */
